import React , { useState } from 'react'
import { Select , Typography , Row , Col , Avatar , Card } from 'antd';
import moment from 'moment';
import Slide from 'react-reveal/Slide';
import { useGetCryptosQuery } from '../services/cryptoApi';
import { useGetCryptosNewsQuery } from '../services/cryptoNewsApi';
import Loader from './Loader';

const { Text,Title } = Typography;
const { Option } = Select;
const demoImg = 'https://www.bing.com/th?id=OVFT.mpzuVZnv8dwIMRfQGPbOPC&pid=News';

const News = ({ simplified }) => {
  const [ newscategory , setNewsCategory ] = useState('Cryptocurrency');
  const { data } = useGetCryptosQuery(100);
  const { data: cryptoNews } = useGetCryptosNewsQuery({ newscategory , count : simplified? 6:12 });
  
  if(!cryptoNews?.value) return <Loader />;
  
  return (
    <Slide right>
    <Row gutter={[24,24]}>
      {!simplified && (
        <Col span={24}>
          <Select
            showSearch
            className='select-news'
            placeholder="select a crypto"
            optionFilterProp='children'
            onChange={(value) => setNewsCategory(value)}
            filterOption = {(input,option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          >
              <Option value='Cryptocurrency'>Cryptocurrency</Option> 
              {data?.data?.coins.map((coin) =>  <Option value={coin.name}>{coin.name}</Option>)}
          </Select>
        </Col>
      )}
      {cryptoNews.value.map((news,i) => (
        <Col xs = {24} sm={12} lg={8} key={i}>
          <Card hoverable className='news-card'>
            <a href={news.url} target="_blank" rel="noreferrer">
              <div className='news-image-container'>
                  <Title className='news-title' level={4}>{news.name}</Title>
                  <img  style={{ maxWidth: '200px' , maxHeight : '100px' }} src={news?.image?.thumbnail?.contentUrl || demoImg } alt='news-img' />
              </div>
              <p>
                { news.description > 100 
                  ? `${news.description.substring(0,100)} ... `
                  : news.description
                }
              </p>
              <div className='provider-container'>
                  <div>
                    <Avatar src = {news.provider[0]?.image?.thumbnail?.contentUrl || demoImg } alt="news-img"/>
                    <Text className='provider-name'>{news.provider[0]?.name}</Text>
                  </div>
                  <Text>{moment(news.datePublished).startOf('ss').fromNow()}</Text>
              </div>
            </a>
          </Card>
        </Col>
      ))}
    </Row>
    </Slide>
  )
}

export default News